module.exports = __webpack_public_path__ + "engineering-culture.3KAF8szN.svg";